export const MEMBERSHIP_EVENTS = {
  MEMBERSHIP_CHANGED: "membershipChanged",
};

export const MEMBERSHIP_CHANGE_TYPES = {
  ADD: "ADD",
  REMOVE: "REMOVE",
  UPDATE: "UPDATE",
  BULK_MOVE: "BULK_MOVE",
};
